import { useEffect } from 'react'

import { language, storeLanguage } from '../i18n'
import { api } from './api'
import type { Settings } from './types'

export function useLanguageSync(settings: Settings | undefined): void {
  useEffect(() => {
    if (!settings || settings.language === language) return

    if (settings.language === 'en' || settings.language === 'ru') {
      storeLanguage(settings.language)
      window.location.reload()
      return
    }

    void api.saveSettings({ ...settings, language })
  }, [settings])
}
